import React, { Component } from 'react';
import { acessoPermitido } from '../../../acessos.seguranca';
import MultiNotasPage from '@common/multinotas/multinotas.page';
import WebapiCommon from '@common/util/webapi.common';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as actions from '../../../pages/laudo/etapas/notas/notas.action';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import NotasApi from './multinotas.api';

class MultiNotasContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listagemNotas: [],
      medicos: [],
      medicoselecionado: null,
      nota: '',
    };
  }

  render() {
    return (
      <MultiNotasPage
        usuario={this.props.usuario}
        acessoPermitido={acessoPermitido}
        listagemNotas={this.state.listagemNotas}
        medicos={this.state.medicos}
        medicoselecionado={this.state.medicoselecionado}
        stateUpdate={this.stateUpdate.bind(this)}
      />
    );
  }

  atualizarNota(value) {
    this.props.actions.atualizarNota(value);
  }

  async componentDidMount() {
    // let laudo = this.props.laudo;
    this.props.commonActions.showFadeCarregando(true);
    Promise.all([
      NotasApi.listarNotas(this.props.detalhes.laudo),
      WebapiCommon.getMedicos(),
    ]).then((response) => {
      let getMedicosResponse = response[1];
      let notas = response[0].data;
      let usuarioLocalStorage = getUsuarioLocalStorage();
      let medicoselecionado = null;

      if (usuarioLocalStorage) {
        medicoselecionado = {
          value: usuarioLocalStorage.medicoId,
          label:
            usuarioLocalStorage.medicoId + ' - ' + usuarioLocalStorage.medico,
        };
      }

      this.setState({
        laudo: this.props.laudo,
        listagemNotas: notas,
        medicos: getMedicosResponse,
        medicoselecionado,
      });

      this.props.commonActions.showFadeCarregando(false);
    });

    const setRows = (id) => {
      if (id) {
        return id.getElementsByTagName('tr');
      }
    };

    const onRowClick = async (tableId, callback) => {
      return new Promise((resolve) => {
        if (!tableId) {
          return;
        }

        const props = this.props;
        let table, rows, i;

        try {
          table = document.getElementById(tableId);
          rows = table.getElementsByTagName('tr');

          const checkExist = setInterval(function () {
            if (rows && rows[0].innerHTML.indexOf('loader') < 0) {
              clearInterval(checkExist);
              for (i = 0; i < rows.length; i++) {
                table.rows[i].onclick = (function (row) {
                  return function () {
                    callback(row, props);
                  };
                })(table.rows[i]);
              }
            } else {
              if (table && rows) {
                table = document.getElementById(tableId);
                rows = setRows(table);
                return;
              } else {
                clearInterval(checkExist);
              }
            }
          }, 300); // check every 100ms
        } catch (error) {
          return setTimeout(() => {
            onRowClick(tableId, callback);
           }, 600);
        }
        resolve();
      });
    };

    await onRowClick('notas-table', function (row, props) {
      if (row.className === 'thead') {
        return;
      }
      const id = row.getElementsByTagName('td')[0].innerHTML;
      if (row.getAttribute('style')) {
        return;
      }

      const rows = document.getElementsByTagName('tr');
      for (let index = 0; index < rows.length; index++) {
        const element = rows[index];
        element.setAttribute('style', '');
      }
      row.setAttribute('style', 'background: #ccc');
      //console.log('ID>>', id);

      WebapiCommon.getTextoLaudoByID(props.detalhes.laudo, 'notas', id)
        .then((res) => {
          commonActions.preencherIdRtf(res.data.id);
          props.actions.atualizarNota(res.data);
          props.actions.selectNota(true);
        })
        .catch((err) => {
          props.actions.atualizarNota({});
          props.actions.selectNota(false);
          commonActions.preencherIdRtf(0);
        });
    });
  }

  adicionarNotas() {
    this.props.commonActions.showFadeCarregando(true);
  }

  stateUpdate = (name, value) =>
    this.setState({
      [name]: value,
    });

  limparNovosRegistros = () => this.setState({ novosregistros: [] });
}

const mapsDispacthToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
  };
};

export default connect(
  mapStateToProps,
  mapsDispacthToProps
)(MultiNotasContainer);



// WEBPACK FOOTER //
// ./src/app/common/multinotas/multinotas.container.js